import { useRef } from 'react'

// The phone studios' tool sheet, dragged by its handle or title bar: it
// follows the finger, then settles at its small or tall height, or closes
// when pulled right down. A tap on the handle still toggles small and tall.
// Spread the result on the sheet's header (`.sx-panel-head`).
const SMALL = 0.46
const TALL = 0.66
const viewport = () => (window.visualViewport && window.visualViewport.height) || window.innerHeight

export function useSheetDrag({ tall, setTall, close }) {
  const drag = useRef(null)

  const onPointerDown = (e) => {
    if (e.button !== undefined && e.button !== 0) return
    if (e.target.closest && e.target.closest('.sx-panel-close')) return
    const panel = e.currentTarget.closest('.sx-panel')
    if (!panel) return
    drag.current = { id: e.pointerId, y: e.clientY, h: panel.getBoundingClientRect().height, panel, moved: false, onGrab: !!(e.target.closest && e.target.closest('.sx-grabber')) }
    try { e.currentTarget.setPointerCapture(e.pointerId) } catch (err) { /* not supported */ }
  }
  const onPointerMove = (e) => {
    const d = drag.current
    if (!d || d.id !== e.pointerId) return
    const dy = e.clientY - d.y
    if (!d.moved && Math.abs(dy) < 6) return
    d.moved = true
    d.panel.style.transition = 'none'
    d.panel.style.height = `${Math.round(Math.min(viewport() * 0.85, Math.max(120, d.h - dy)))}px`
  }
  const end = (e, cancelled) => {
    const d = drag.current
    if (!d || d.id !== e.pointerId) return
    drag.current = null
    const { panel } = d
    const h = panel.getBoundingClientRect().height
    const vh = viewport()
    panel.style.transition = ''
    panel.style.height = ''
    if (!d.moved) { if (!cancelled && d.onGrab) setTall(!tall); return }
    if (cancelled) return
    if (h < vh * 0.3) close()
    else setTall(h > vh * ((SMALL + TALL) / 2))
  }

  return {
    onPointerDown,
    onPointerMove,
    onPointerUp: (e) => end(e, false),
    onPointerCancel: (e) => end(e, true),
  }
}
